  //学习空间
  export const studyzoneRouters = [{
      path: "/studentHome",
      name: "studentHome",
      props: true,
      component: () => import("../views/StudyZone/Home.vue"),
      meta: {
          title: "学生空间",
          needJudgeLogin: true
      },
      children: [{
              path: "myCourse",
              name: "myCourse",
              meta: {
                  title: "我的课程",
                  needJudgeLogin: true
              },
              component: () => import("../views/StudyZone/components/myCourse.vue")
          },
          {
              path: "notice",
              name: "myNotice",
              meta: {
                  title: "我的公告",
                  needJudgeLogin: true
              },
              component: () => import("../views/StudyZone/components/notice.vue")
          },
          {
              path: "info",
              name: "myInfo",
              meta: {
                  title: "我的信息",
                  needJudgeLogin: true
              },
              component: () => import("../views/StudyZone/components/info.vue")
          },
          {
              path: "collect",
              name: "myCollect",
              meta: {
                  title: "我的收藏",
                  needJudgeLogin: true
              },
              component: () => import("../views/StudyZone/components/collect.vue")
          }
      ]
  }]